import { useNavigate } from "react-router-dom";
import Header from "../../../components/common/header";
import TransitionWrapper from "../../../components/common/transition-wrapper";
import Menu from "../components/menu";
import { useAuth } from "../../../core/auth";
import { useCart } from "../../../core/cart";
import { track } from "@amplitude/analytics-browser";
import { postMessage } from "../../../core/message";
import { FaUser, FaGift, FaHeadset, FaCog, FaSignOutAlt } from "react-icons/fa";

export default function Settings() {
  const { logout, loginAdmin, changeLastPage } = useAuth();
  const navigate = useNavigate();
  const { clearCart } = useCart();

  async function handleSellerLoginClick() {
    const sellerToken = localStorage.getItem("sellerToken");
    if (sellerToken) {
      await loginAdmin();
      changeLastPage();
      navigate("/boss/home");
    } else {
      navigate("/boss/login");
    }
  }

  function onClickLogout() {
    clearCart();
    localStorage.removeItem("jwt");
    localStorage.removeItem("user_storeReview_isTarget");
    postMessage("REQ_STOP_STORE_REVIEW", {});
    logout();
    navigate("/");
    window.location.reload();
  }

  return (
    <div className="w-full h-full flex flex-col overflow-y-auto bg-gray-50">
      <Header title="설정" showBackButton />
      <div className="w-full px-4 py-4 space-y-4">
        {/* 내 활동 */}
        <div className="bg-white rounded-xl p-4">
          <h3 className="text-sm font-bold text-black mb-3 flex items-center gap-3">
            <FaUser className="text-blue-500 text-lg" />내 활동
          </h3>
          <div className="space-y-1">
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="내 스탬프"
                to="/frequency"
                onClick={() => {
                  track("내 스탬프 진입로 클릭", { 어디서: "설정" });
                }}
              />
            </TransitionWrapper>
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="내가 쓴 리뷰"
                to="/my/review"
                onClick={() => {
                  track("내가 쓴 리뷰 클릭", { 어디서: "설정" });
                }}
              />
            </TransitionWrapper>
          </div>
        </div>

        {/* 혜택/쿠폰 */}
        <div className="bg-white rounded-xl p-4">
          <h3 className="text-sm font-bold text-black mb-3 flex items-center gap-3">
            <FaGift className="text-pink-500 text-lg" />
            혜택/쿠폰
          </h3>
          <div className="space-y-1">
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="내 쿠폰함"
                to="/my/coupon"
                onClick={() => {
                  track("내 쿠폰함 클릭", { 어디서: "설정" });
                }}
              />
            </TransitionWrapper>
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="할인코드 입력"
                to="/my/coupon/register"
                onClick={() => {
                  track("할인코드 입력 클릭", { 어디서: "설정" });
                }}
              />
            </TransitionWrapper>
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="친구 코드 등록하기"
                to="/my/invite/register"
                onClick={() => {
                  track("친구 코드 등록하기 클릭", { 어디서: "설정" });
                }}
              />
            </TransitionWrapper>
          </div>
        </div>

        {/* 고객지원 */}
        <div className="bg-white rounded-xl p-4">
          <h3 className="text-sm font-bold text-black mb-3 flex items-center gap-3">
            <FaHeadset className="text-green-500 text-lg" />
            고객지원
          </h3>
          <div className="space-y-1">
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu title="문의하기" to="/my/customer-service" />
            </TransitionWrapper>
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="매장 추천하기"
                to="https://forms.gle/PXmEvzq4LsNDC1Gj9"
              />
            </TransitionWrapper>
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu title="약관 및 정책" to="/my/policy" />
            </TransitionWrapper>
          </div>
        </div>

        {/* 계정 설정 */}
        <div className="bg-white rounded-xl p-4">
          <h3 className="text-sm font-bold text-black mb-3 flex items-center gap-3">
            <FaCog className="text-purple-500 text-lg" />
            계정 설정
          </h3>
          <div className="space-y-1">
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu title="알림설정" to="/notification-settings" />
            </TransitionWrapper>
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="본인 인증"
                onClick={() => navigate("/phone-number-auth?allowBack=true")}
              />
            </TransitionWrapper>
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu title="비밀번호 재설정" to="/change-password" />
            </TransitionWrapper>
          </div>
        </div>

        {/* 로그아웃/탈퇴 */}
        <div className="bg-white rounded-xl p-4">
          <h3 className="text-sm font-bold text-black mb-3 flex items-center gap-3">
            <FaSignOutAlt className="text-red-500 text-lg" />
            로그아웃/탈퇴
          </h3>
          <div className="space-y-1">
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="사장님 로그인 (회원가입)"
                onClick={() => handleSellerLoginClick()}
              />
            </TransitionWrapper>
            <TransitionWrapper scale={0.95} opacity={0.5}>
              <Menu
                title="로그아웃"
                onClick={() => {
                  track("로그아웃 클릭", { 어디서: "설정" });
                  onClickLogout();
                }}
              />
            </TransitionWrapper>
            <Menu
              title="계정탈퇴"
              to="/sign-out"
              onClick={() => {
                track("계정탈퇴 클릭", { 어디서: "설정" });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
